exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-2feb0680] small {\n\tfont-size: 1em !important;\n}\n.tab[data-v-2feb0680] {\n\tborder-bottom-width: 2px;\n}\n.tab.active[data-v-2feb0680] {\n\tcolor: #00aef1;\n\tborder-bottom: solid 2px #00aef1 !important;\n}\n", ""]);

// exports
